module.exports = __webpack_public_path__ + "static/media/landing-chart.8cb50f5c.svg";